import { Observable } from 'rxjs';
import { AppEvent } from '../models/app-events.models';

export abstract class AppEventsApi {
  readonly events$: Observable<AppEvent>;

  abstract dispatchEvent(event: AppEvent): void;
}
